module.exports = __webpack_public_path__ + "static/media/baby-carriage.cc786d4e.svg";